/**
 * Forces multiple calls to a function to execute
 * only once, and after a set time
 * @param  {Function} fn [The function to debounce]
 * @param  {[number]} delay [The debounce interval - ms]
 */
const debounce = <T extends (...args: any[]) => void>(fn: T, delay: number): T => {
    let timeout: any;

    return ((...args: Parameters<T>) => {
        clearTimeout(timeout);

        if (delay) {
            timeout = setTimeout(() => {
                fn(...args);
            }, delay);
        } else {
            fn(...args);
        }
    }) as any;
};

export default debounce;
